 
export default function errorClass(ungueltig) {
    return (ungueltig ? 'is-invalid' : '');
  }

  